import { render } from "./BaseVideo.vue?vue&type=template&id=cbfed1c8"
import script from "./BaseVideo.vue?vue&type=script&lang=js"
export * from "./BaseVideo.vue?vue&type=script&lang=js"

import "./BaseVideo.vue?vue&type=style&index=0&id=cbfed1c8&lang=css"
script.render = render

export default script